import React from 'react'
import { ErrorFallback } from './ErrorFallback'
import { logAppError } from '../../../helpers/errorHelper'

type AppErrorBoundaryProps = {
   children: React.ReactNode
}
type AppErrorBoundaryState = {
   error: unknown
}

// Catching here unmounts the provider tree, including the auth listeners and session timers,
// so the fallback only offers a full reload - it rebuilds that state from scratch.
export class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
   state: AppErrorBoundaryState = { error: null }

   static getDerivedStateFromError(error: unknown): AppErrorBoundaryState {
      return { error }
   }

   componentDidCatch(error: unknown, errorInfo: React.ErrorInfo): void {
      logAppError(error, errorInfo.componentStack)
   }

   render(): React.ReactNode {
      if (this.state.error !== null) {
         return <ErrorFallback error={this.state.error} />
      }
      return this.props.children
   }
}
